import { render, staticRenderFns } from "./messengerButton.vue?vue&type=template&id=92aa4876&scoped=true&"
import script from "./messengerButton.vue?vue&type=script&lang=js&"
export * from "./messengerButton.vue?vue&type=script&lang=js&"
import style0 from "./messengerButton.vue?vue&type=style&index=0&id=92aa4876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92aa4876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/integrationtest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92aa4876')) {
      api.createRecord('92aa4876', component.options)
    } else {
      api.reload('92aa4876', component.options)
    }
    module.hot.accept("./messengerButton.vue?vue&type=template&id=92aa4876&scoped=true&", function () {
      api.rerender('92aa4876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messengerButton.vue"
export default component.exports